<template>
  <div class="add-order" id="addOrder">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toOrderList">返修单/</span>新增返修
      </template>
      <template v-slot:content>
        <div class="order-detail" ref="orderDetail">
          <div class="customer-input-container">
            <div class="customer-input">
              <i class="require-icon"></i>
              <span class="desc">小b名称：</span>
              <el-autocomplete
                class="customer-input"
                v-model="selectedCustomerName"
                ref="searchClientByTableEle"
                type="text"
                :fetch-suggestions="searchClientByInput"
                placeholder="请输入客户名或手机号"
                @select="onSelectClient"
              >
                <div
                  class="icon-container"
                  slot="suffix"
                  @click="toSelectClientByTable"
                >
                  <svg
                    class="icon"
                    style
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    p-id="3293"
                    width="18"
                    height="18"
                  >
                    <path
                      d="M654.336 483.328c78.336 0 142.336-63.488 142.336-142.336s-63.488-142.336-142.336-142.336c-15.872 0-28.672-12.8-28.672-28.672 0-15.872 12.8-28.672 28.672-28.672 110.08 0 199.168 89.088 199.168 199.168 0 66.56-33.28 129.024-88.576 165.888 118.784 52.736 202.752 188.416 202.752 346.112 0 15.872-12.8 28.672-28.672 28.672h-85.504c-15.872 0-28.672-12.8-28.672-28.672 0-15.872 12.8-28.672 28.672-28.672h55.808c-11.776-160.256-122.368-284.672-254.976-284.672-15.872 0-28.672-12.8-28.672-28.672 0-14.336 12.8-27.136 28.672-27.136z m-349.184 50.688C199.168 466.944 166.912 326.144 233.984 220.16S441.856 81.92 547.84 148.992s138.24 207.36 71.168 313.856c-17.92 28.672-42.496 53.248-71.168 71.168 144.896 54.272 248.32 202.24 248.32 376.32 0 15.872-12.8 28.672-28.672 28.672H85.504c-15.872 0-28.672-12.8-28.672-28.672 0-174.08 103.424-322.56 248.32-376.32z m121.344-22.016c94.208 0 170.496-76.288 170.496-170.496s-76.288-170.496-170.496-170.496C332.288 170.496 256 247.296 256 341.504S332.288 512 426.496 512z m0 56.832c-163.328 0-298.496 137.216-311.808 312.832h623.616c-13.312-175.616-147.968-312.832-311.808-312.832z"
                      p-id="3294"
                      fill="#939393"
                    />
                  </svg>
                </div>
              </el-autocomplete>
            </div>
          </div>
          <div class="table-img selected-commodity">
            <el-table
              max-height="350"
              class="table-container"
              :data="selectedGoodList"
            >
              <el-table-column label="商品名称">
                <template slot-scope="props" align="center">
                  <img
                    class="img"
                    width="20"
                    height="20"
                    :src="props.row.commodityImg"
                    alt="商品图"
                  />
                  <div class="name">{{ props.row.commodityName }}</div>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="120">
                <template slot-scope="props">
                  <int-input
                    class="good-amount"
                    :updateIndex="props.$index"
                    :intNum="Number(props.row.amount)"
                    @update="onUpdateAmount"
                    @complete="filterAmountNum"
                  ></int-input>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                prop="message"
                width="284"
              >
              <template slot-scope="props">
                <div class="temporary-remarks">
                  <el-input v-model="props.row.message" maxlength="20"></el-input>
                </div>
              </template>
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="props">
                  <span
                    class="delete-btn"
                    @click="deleteSelectedGood(props.row)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="add-commodity-btn">
            <span class="add-btn" @click="toAddCommodity">添加商品</span>
          </div>
          <div class="temporary-container">
            <div
              class="temporary-item"
              v-for="(value, index) in temporaryData"
              :key="index"
            >
              <div class="temporary-name">
                <el-input class="gray" v-model="value.goodsName"></el-input>
              </div>
              <div class="temporary-num">
                <int-input
                  class="good-amount"
                  :updateIndex="index"
                  :intNum="Number(value.quantity)"
                  @update="onUpdateTemporary"
                  @complete="filterTemporary"
                ></int-input>
              </div>
              <div class="temporary-remarks">
                <el-input v-model="value.message" maxlength="10"></el-input>
              </div>
              <div class="temporary-operation">
                <span class="delete-btn" @click="delTemporary(index)"
                  >删除</span
                >
              </div>
            </div>
          </div>
          <div class="add-commodity-btn" v-if="moduleTempGoods">
            <span class="add-btn" @click="addTemporary">添加临时商品</span>
          </div>
        </div>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="cancelNewOrder">取消</el-button>
          <el-button class="btn-blue" @click="createNewOrder">保存</el-button>
        </div>
        <!-- 选择客户--弹框 -->
        <el-dialog
          class="add-customer-container"
          :close-on-click-modal="false"
          :visible.sync="isShowClientListDialog"
        >
          <span slot="title">选择客户</span>
          <div class="content">
            <div class="search-key-tag">
              <div class="search-key">
                <el-input
                  v-model="searchClientForm.key"
                  @keyup.enter.native="searchClientByTable(1)"
                  class="gray"
                  placeholder="请输入客户名称或手机号"
                ></el-input>
              </div>
              <div class="search-tag">
                <el-select
                  class="gray"
                  v-model="searchClientForm.tagId"
                  placeholder="请选择客户标签"
                  clearable
                >
                  <el-option
                    v-for="item in tagList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <el-button class="btn-blue" @click="searchClientByTable(1)"
                >搜索</el-button
              >
            </div>
            <!-- 客户列表 -->
            <div class="clientList table">
              <el-table class="table-container" :data="clientList" height="250">
                <el-table-column label="选择" width="64px">
                  <template slot-scope="props">
                    <el-radio v-model="selectedXbId" :label="props.row.xbId"
                      >&nbsp;&nbsp;</el-radio
                    >
                  </template>
                </el-table-column>
                <el-table-column label="客户名称" prop="name"></el-table-column>
                <el-table-column
                  label="联系人"
                  prop="contact"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  label="手机号"
                  prop="telephone"
                  width="125px"
                ></el-table-column>
                <el-table-column label="账号状态" width="100px">
                  <template slot-scope="props">
                    <div class="status-desc-container">
                      <span class="status-desc" v-show="props.row.status === 0"
                        >未审核</span
                      >
                      <span class="status-desc" v-show="props.row.status === 1"
                        >已启用</span
                      >
                      <span class="status-desc" v-show="props.row.status === 2"
                        >已禁用</span
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-container">
              <pagination-tpl
                :total="customerTotalNum"
                @queryChange="updatePage"
                :currentPage="goodsCurrentPage"
              ></pagination-tpl>
            </div>
            <div class="operation">
              <el-button class="btn-white" @click="cancelCustomer"
                >取消</el-button
              >
              <el-button class="btn-blue" @click="selectCustomer"
                >保存</el-button
              >
            </div>
          </div>
        </el-dialog>
        <!-- 添加商品--弹框 -->
        <el-dialog
          class="add-good-dialog"
          title="添加商品"
          :visible.sync="isShowGoodDialog"
          width="1152px"
          :close-on-click-modal="false"
          top="5vh"
        >
          <!-- 黑色的线条 -->
          <div class="border"></div>
          <!-- 表格部分 -->
          <div class="flex">
            <div class="flex-left">
              <div class="dialog-search">
                <el-input
                  class="gray"
                  placeholder="请输入商品名称"
                  @keyup.enter.native="filterCommodity"
                  v-model="searchKey"
                ></el-input>
                <el-button type="text" class="btn-blue" @click="filterCommodity"
                  >搜索</el-button
                >
              </div>
              <div class="table-img goods-list">
                <el-table
                  height="338"
                  :data="commodityList"
                  style="width: 100%"
                  ref="flexRightTable"
                >
                  <el-table-column label="商品名称">
                    <template slot-scope="props">
                      <div class="name-norm-container">
                        <div class="name-price">
                          <div class="good-name">
                            {{ props.row.commodityName }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="props">
                      <el-button
                        class="btn-text"
                        type="text"
                        @click="selectGoodInDialog(props.row)"
                        >选择</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table_pagination">
                  <pagination-tpl
                    :total="goodsTotal"
                    :currentPage="goodsCurrentPage"
                    @queryChange="onGoodsCurrPageChange"
                  ></pagination-tpl>
                </div>
              </div>
            </div>
            <div class="flex-right">
              <div class="table-img">
                <el-table
                  height="400"
                  :data="tmpShowSelectedGoodList"
                  style="width: 100%"
                >
                  <el-table-column label="商品名称">
                    <template slot-scope="scope">
                      <div class="flex-right-good-name">
                        {{ scope.row.commodityName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <div
                        class="delete-btn"
                        @click="deleteGoodInDialog(scope.row)"
                      >
                        删除
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button class="btn-white" @click="cancelCommodity"
              >取消</el-button
            >
            <el-button class="btn-blue" @click="saveCommodity">确定</el-button>
          </div>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import { getDBModuleStatusPermission } from "common/js/storage";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import IntInput from "components/base/IntInput";
import DecimalInput from "components/base/DecimalInput";
import DBClient from "models/db/client.js";
import DBOrder from "models/db/order.js";
import DBCommodity from "models/db/commodity.js";
import DBAddress from "models/db/address.js";
const dbClient = new DBClient();
const dbCommodity = new DBCommodity();
const dbAddress = new DBAddress();
const dbOrder = new DBOrder();
export default {
  data() {
    return {
      // 新增订单的小b名称
      selectedCustomerName: "",
      // 客户标签列表
      tagList: [],
      // 当前哪个客户被选中了--xbId
      selectedXbId: 0,
      // 选择客户--弹框
      isShowClientListDialog: false,
      // 搜索客户的条件
      searchClientForm: {
        key: "",
        tagId: "",
      },
      //客户页码
      customerPage: 1,
      // 客户总数
      customerTotalNum: 0,
      // 客户列表
      clientList: [],
      // 外部客户搜索框列表
      serachClientList: [],
      // 选择商品--弹框
      isShowGoodDialog: false,
      // 商品列表相关--搜索关键字
      searchKey: "",
      // 搜索商品的参数
      filterGoodsOptions: {
        currentPage: 1,
        xbId: 1,
        goodsName: "",
      },
      // 商品列表总数
      goodsTotal: 0,
      goodsCurrentPage: 1,
      // 弹框展示的商品列表
      commodityList: [],
      // 被添加商品的商品列表
      selectedGoodList: [],
      // 编辑时将要添加的商品
      tmpSelectedGoodList: [],
      //临时商品数据
      moduleTempGoods: false,
      temporaryData: [],
      updateTemporaryIndex: "",
    };
  },
  computed: {
    // 临时选中的商品列表
    tmpShowSelectedGoodList() {
      const goodList = [];
      this.tmpSelectedGoodList.map((item) => {
        // 被选择的要保存
        let normDesc = "";
        let normValue = item.normValue;
        normValue.map((norm, index) => {
          if (index !== normValue.length - 1) {
            normDesc += `${norm.value};`;
          } else {
            normDesc += `${norm.value}`;
          }
        });
        goodList.push({
          commodityImg: item.commodityImg,
          commodityName: item.commodityName,
          normDesc: normDesc,
          price: item.price,
          id: item.id,
        });
      });
      return goodList;
    },
  },
  watch: {
    selectedXbId(newVal, oldVal) {
      console.log("客户变化了");
      if (!newVal || newVal !== oldVal) {
        this.selectedGoodList = [];
        this.tmpSelectedGoodList = [];
      }
    },
    isShowClientListDialog: {
      handler(newVal, oldVal) {
        let suggestListEle = document.querySelector(
          ".el-autocomplete-suggestion"
        );
        if (newVal) {
          suggestListEle.style.transform = "scale(0)";
        }
      },
    },
    isShowGoodDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.filterGoodsOptions = {
            currentPage: 1,
            xbId: this.selectedXbId,
            goodsName: this.searchKey,
          };
          this._getCommodityListWithNorm(this.filterGoodsOptions);
        } else {
          // 将所有临时选中的置空
          this.tmpSelectedGoodList = [];
        }
      },
    },
    commodityList: {
      deep: true,
      handler(newVal, oldVal) {
        // 规格取值变动计算skuId
        newVal.map((item) => {
          let skuIdStr = this._normValueToSkuIdStr(item.normValue);
          let sku = item.skuList.find((skuItem) => skuIdStr === skuItem.value);
          if (sku) {
            item.skuId = sku.skuId;
            item.price = sku.price;
          }
        });
      },
    },
    selectedGoodList: {
      deep: true,
      handler(newVal, oldVal) {
        newVal.map((item) => {
          item.subtotal = (Number(item.price) * Number(item.amount)).toFixed(2);
        });
      },
    },
  },
  methods: {
    onUpdateAmount(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterAmountNum(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.selectedGoodList[this.updateCommodityIndex])
      );
      commodity.amount = val;
      this.selectedGoodList.splice(this.updateCommodityIndex, 1, commodity);
    },
    onUpdateGoodAmount(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterGoodAmountNum(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.commodityList[this.updateCommodityIndex])
      );
      commodity.amount = val;
      this.commodityList.splice(this.updateCommodityIndex, 1, commodity);
    },
    // 查询商品
    filterCommodity() {
      this.filterGoodsOptions = {
        currentPage: 1,
        xbId: this.selectedXbId,
        goodsName: this.searchKey,
      };
      this._getCommodityListWithNorm(this.filterGoodsOptions);
    },
    // 客户弹框的搜索
    searchClientByTable(currentPage) {
      this.goodsCurrentPage = currentPage;
      const telephoneReg = /^1[0-9]{10}$/;
      let isTelephone = telephoneReg.test(Number(this.searchClientForm.key));
      let options = {
        name: isTelephone ? "" : this.searchClientForm.key,
        telephone: isTelephone ? this.searchClientForm.key : "",
        label: this.searchClientForm.tagId,
        currentPage: this.goodsCurrentPage,
      };
      this._getClientList(options);
    },
    //客户翻页
    updatePage(data) {
      this.searchClientByTable(data.currentPage);
    },
    // 输入框查询客户
    searchClientByInput(query, cb) {
      if (query === "") {
        this.selectedXbId = 0;
      }
      let options = {
        name: query,
      };
      this._searchClientByInput(options, cb);
    },
    // 根据客户姓名关键字查询客户
    _searchClientByInput(options, cb) {
      dbClient.getClientList(options).then((res) => {
        if (res.success) {
          this.serachClientList = [];
          res.result.items.map((item) => {
            if (item.name || item.telephone) {
              this.serachClientList.push({
                value: `${item.name ? item.name + ";" : ""}${item.telephone}`,
                id: item.id,
              });
            }
          });
          cb(this.serachClientList);
        }
      });
    },
    toAddCommodity() {
      // 如果没有选择客户，提示应该先选择客户
      if (this.selectedCustomerName) {
        this._showGoodDialog();
      } else {
        this.$message({
          message: "请先输入小b名称",
          type: "error",
        });
      }
    },
    //添加临时商品
    addTemporary() {
      let obj = {
        goodsName: "",
        goodsPic: "",
        goodsId: 0,
        quantity: 1,
        message: "",
      };
      this.temporaryData.push(obj);
    },
    //删除临时商品
    delTemporary(index) {
      this.temporaryData.splice(index, 1);
    },
    //修改临时商品数量
    onUpdateTemporary(updateIndex) {
      this.updateTemporaryIndex = updateIndex;
    },
    filterTemporary(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.temporaryData[this.updateTemporaryIndex])
      );
      commodity.quantity = val;
      this.temporaryData.splice(this.updateTemporaryIndex, 1, commodity);
    },
    // 新建订单
    _createNewOrder(data) {
      dbOrder
        .createNewRepairOrder(data)
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "创建成功",
              center: true,
              type: "success",
              duration: 1000,
            });
            this.toOrderList();
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: "创建失败",
            center: true,
            type: "error",
            duration: 1000,
          });
        });
    },
    _showGoodDialog() {
      this.isShowGoodDialog = true;
    },
    _hideGoodDialog() {
      this.isShowGoodDialog = false;
    },
    onSelectClient(item) {
      this.selectedXbId = item.id;
    },
    toSelectClientByTable() {
      this._showClientListDialog();
    },
    _showClientListDialog() {
      this.isShowClientListDialog = true;
    },
    _hideCustomerDialog() {
      this.isShowClientListDialog = false;
    },
    toOrderList() {
      this.$router.push({
        name: "repair-list",
        params: {
          change: true,
        },
      });
    },
    cancelCustomer() {
      // 将客户被选中的状态取消
      this.selectedXbId = "";
      this.selectedCustomerName = "";
      this._hideCustomerDialog();
    },
    selectCustomer() {
      let selectedCustomer = null;
      this.clientList.map((item) => {
        if (item.xbId === this.selectedXbId) {
          selectedCustomer = item;
        }
      });
      if (!selectedCustomer) {
        this.$alert("您尚未选择客户", "操作提示", {
          confirmButton: "确定",
          type: "warnning",
        });
        return false;
      }
      this.selectedCustomerName = selectedCustomer.name;
      this._hideCustomerDialog();
    },
    cancelNewOrder() {
      this.$router.push({
        path: "/admin/order/repair-form/repair-list",
      });
    },
    createNewOrder() {
      // 校验客户不能为空
      if (!this.selectedXbId) {
        this.$alert("请选择具体客户", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      // if (!this.selectedGoodList.length) {
      //   this.$alert("请选择商品", "操作提示", {
      //     confirmButtonText: "确定",
      //   });
      //   return false;
      // }
      //验证临时商品
      let temporaryStop = false;
      this.temporaryData.map((value) => {
        if (value.goodsName === "") {
          temporaryStop = true;
        }
      });
      if (temporaryStop) {
        this.$alert("请填入完整临时商品信息", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      let xbId = this.selectedXbId;
      let goodsInfo = [];
      this.temporaryData.map(i => {
        goodsInfo.push(i)
      })
      this.selectedGoodList.map((item) => {
        goodsInfo.push({
          quantity: item.amount,
          goodsId: item.id,
          goodsName: item.commodityName,
          goodsPic: item.commodityImg,
          message: item.message,
        });
      });
      let data = {
        xbId: xbId,
        goodsList: goodsInfo,
      };
      this._createNewOrder(data);
    },
    cancelCommodity() {
      this._hideGoodDialog();
    },
    // 商品列表弹框--选择商品
    selectGoodInDialog(good) {
      const _good = JSON.parse(JSON.stringify(good));
      console.log("选择的商品", good);
      console.log("此时的临时商品列表--", this.tmpSelectedGoodList);
      const found = this.tmpSelectedGoodList.find(
        (item) => item.id === _good.id && item.skuId === _good.skuId
      );
      if (found === undefined) {
        this.tmpSelectedGoodList.push(_good);
      } else {
        this.$message({
          message: "该商品已添加",
          type: "error",
        });
      }
    },
    // 商品列表弹框--删除商品
    deleteGoodInDialog(good) {
      const targetIndex = this.tmpSelectedGoodList.findIndex(
        (item) => item.id === good.id
      );
      console.log(targetIndex);
      this.tmpSelectedGoodList.splice(targetIndex, 1);
    },
    saveCommodity() {
      // 保存选中的商品
      // 首先判断选中的商品和订单里之前已有的商品是否重复
      let isRepeat = false;
      this.selectedGoodList.map((oldCommodity) => {
        this.tmpSelectedGoodList.map((newCommodity) => {
          if (newCommodity.skuId === oldCommodity.skuId) {
            // 说明有重复的
            isRepeat = true;
          }
        });
      });
      if (isRepeat) {
        this.$alert("您重复添加了商品，请重新选择", "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return false;
      }
      // 如果没有重复商品，那么保存
      this.tmpSelectedGoodList.map((item) => {
        // 被选择的要保存
        let normDesc = "";
        let normValue = item.normValue;
        normValue.map((norm, index) => {
          if (index !== normValue.length - 1) {
            normDesc += `${norm.value}，`;
          } else {
            normDesc += `${norm.value}`;
          }
        });
        let subtotal = (Number(item.price) * item.amount).toFixed(2);
        this.selectedGoodList.push({
          id: item.id,
          commodityImg: item.commodityImg,
          commodityName: item.commodityName,
          normDesc: normDesc,
          price: item.price,
          amount: item.amount,
          subtotal: subtotal,
          skuId: item.skuId,
          message: ''
        });
      });
      this._hideGoodDialog();
    },
    // 删除已选中的商品
    deleteSelectedGood(good) {
      let index = good.$index;
      this.selectedGoodList.splice(index, 1);
    },
    // 商品列表翻页
    onGoodsCurrPageChange(option) {
      console.log("分页--", option.currentPage);
      this.filterGoodsOptions.currentPage = option.currentPage;
      this._getCommodityListWithNorm(this.filterGoodsOptions);
    },
    // 获取商品列表
    _getCommodityListWithNorm(options) {
      dbCommodity.getCommodityListWithNorm(options).then((res) => {
        if (res.success) {
          // 查询到以后
          let { totalNum, items, currentPage } = res.result;
          this.goodsTotal = totalNum;
          this.goodsCurrentPage = currentPage;
          let commodityList = items;
          // 先置空
          this.commodityList = [];
          commodityList.map((item) => {
            let imgList = item.itemImages;
            let normList = item.specificationItems;
            let normValue = [];
            for (let i = 0; i < normList.length; i++) {
              let key = normList[i].name;
              let valueArr = normList[i].value;
              normValue.push({
                key: key,
                value: valueArr[0],
              });
            }
            let skuList = [];
            // item.items--商品的不同规格的sku以及价格
            item.items.map((item) => {
              let specInfo = {};
              normValue.map((val) => {
                specInfo[val.key] = item.specInfo[val.key];
              });
              skuList.push({
                skuId: item.id,
                price: item.marketPrice,
                value: JSON.stringify(specInfo),
              });
            });
            this.commodityList.push({
              // 商品id
              id: item.id,
              commodityImg: imgList[0],
              commodityName: item.goodsName,
              normList: normList,
              normValue: normValue,
              skuList: skuList,
              skuId: skuList[0].skuId,
              classify: item.categoryName,
              price: skuList[0].price,
              amount: 1,
            });
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 输入normValue输出skuIdStr
    _normValueToSkuIdStr(normValue = []) {
      let result = {};
      normValue.map((item) => {
        let key = item.key;
        let value = item.value;
        result[key] = value;
      });
      return JSON.stringify(result);
    },
  },
  created() {
    //是否可以添加临时商品
    this.moduleTempGoods = getDBModuleStatusPermission().moduleTempGoods === 1;
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.orderDetail.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.orderDetail.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
    IntInput,
    DecimalInput,
  },
};
</script>

<style lang="scss" scoped>
.add-order {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 500;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .order-detail {
    .customer-input-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      .customer-input {
        margin-right: 8px;
        .require-icon {
          width: 10px;
          height: 10px;
          background: url("../../../../assets/commodity/required.png");
          background-size: 10px 10px;
        }
        .desc {
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
        }
        .customer-input {
          .el-input {
            .el-input__inner {
              width: 200px;
            }
          }
          .icon-container {
            box-sizing: border-box;
            height: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
        }
      }
    }
    .selected-commodity {
      .good-amount {
        /* width: 60px; */
      }
      .delete-btn {
        cursor: pointer;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
      }
    }
    .add-commodity-btn {
      width: 100%;
      height: 32px;
      line-height: 20px;
      padding: 6px 0 6px 16px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      color: rgba(61, 116, 242, 1);
      border: 1px solid #eee;
      border-top: none;
      .add-btn {
        cursor: pointer;
      }
    }
    .temporary-container {
      border-right: 1px solid #eee;
      border-left: 1px solid #eee;
      .temporary-item {
        height: 56px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        .temporary-name {
          width: 200px;
          flex: 1;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .temporary-spec {
          flex: 1;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .temporary-price {
          width: 120px;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .temporary-num {
          width: 120px;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .temporary-remarks {
          width: 284px;
          height: 32px;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .temporary-operation {
          width: 180px;
          box-sizing: border-box;
          padding: 0 16px;
        }
        .delete-btn {
          cursor: pointer;
          font-size: 12px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(61, 116, 242, 1);
        }
      }
    }dress {
      margin-top: 20px;
      display: flex;
      .btn-container {
        margin-left: 12px;
        .select-address-btn {
          cursor: pointer;
          font-size: 12px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(61, 116, 242, 1);
        }
      }
    }
  }
  .operations {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
  }
  // 添加商品弹框
  .el-dialog {
    .flex {
      display: flex;
      height: 360px;
      border-bottom: 1px solid #f7f7f7;
      .flex-left {
        width: 624px;
        padding-right: 19px;
        box-sizing: border-box;
        border-right: 1px solid #e2e2e2;
        .dialog-search {
          margin-bottom: 16px;
          .el-input {
            width: 240px;
            margin-right: 16px;
          }
          .el-button {
            width: 60px;
          }
        }
        .table_pagination {
          display: flex;
          justify-content: flex-end;
        }
      }
      .flex-right {
        width: 546px;
        padding: 16px 16px 10px 20px;
        box-sizing: border-box;
        .table-img {
          width: 510px;
          height: 100%;
        }
        .flex-right-good-name {
          box-sizing: border-box;
          width: 170px;
          padding-right: 10px;
          padding-left: 10px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .flex-right-norm-desc {
          box-sizing: border-box;
          padding-right: 10px;
          width: 220px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
        }
        .flex-right-good-price {
          box-sizing: border-box;
          padding-right: 10px;
          width: 62px;
        }
        .specifications {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          .specifications-left {
            display: flex;
            align-items: center;
            .specifications-title {
              line-height: 32px;
              display: flex;
              align-items: center;
            }
            .specifications-list {
              display: flex;
              margin-left: 6px;
              .specifications-label {
                max-width: 68px;
                line-height: 32px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .el-select {
                width: 80px;
              }
            }
          }
          .el-button {
            width: 50px;
            padding: 0;
          }
        }
      }
    }
    .dialog-footer {
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
#addOrder {
  .customer-input {
    .el-input {
      width: 360px;
    }
  }
  .temporary-remarks {
    .el-input__inner,
    .el-input {
      height: 32px;
    }
    .el-input__inner {
      background: rgba(245, 247, 250, 0.5);
    }
  }
  .delivery-dialog {
    .el-table {
      border: 1px solid #eee;
      border-bottom: none;
      td,
      th {
        padding: 5px 0px;
        background: rgba(245, 247, 250, 0.4);
      }
      .cell {
        display: flex;
      }
    }
    .el-radio__label {
      font-size: 12px;
      font-weight: 400;
      color: #606266;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #df3445;
      background: #fff;
    }
    .el-radio__inner::after {
      background-color: #df3445;
    }
    .el-radio__inner:hover {
      border-color: #df3445;
    }
    .delivery-title {
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .mark {
        margin-right: 5px;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .el-dialog {
      width: 520px;
      border-radius: 8px;
    }
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      // padding: 11px 20px;
      padding-left: 16px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
      }
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__body {
      padding: 20px 35px 32px 35px;
    }
    .el-dialog__footer {
      padding: 10px;
      border-top: 1px solid #eee;
      .btn {
        width: 60px;
        height: 24px;
        border-radius: 4px;
      }
      .cancel-btn {
        margin-right: 24px;
        border: 1px solid #df3446;
        color: #df3445;
      }
      .confirm-btn {
        color: #ffffff;
        background: #df3445;
      }
    }
  }
  /* 商品弹框列表 */
  .el-dialog__wrapper.add-good-dialog {
    .el-dialog {
      .el-dialog__header {
        height: 38px;
        display: flex;
        align-items: center;
        .el-dialog__title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(102, 102, 102, 1);
          line-height: 24px;
        }
      }
      .el-dialog__body {
        .flex {
          height: 451px;
        }
      }
      .table-img {
        .el-table {
          .el-table__header-wrapper {
            .el-table__header {
              .has-gutter {
                tr {
                  th {
                    font-family: "SimSun";
                  }
                }
              }
            }
          }
          .el-table__body-wrapper {
            .el-table__body {
              tbody {
                tr {
                  td {
                    .cell {
                      font-family: "SimSun";
                    }
                  }
                }
              }
            }
          }
        }
      }
      .goods-list {
        .el-select.gray {
          .el-input {
            height: 24px;
            width: 100px;
            .el-input__inner {
              height: 24px;
              width: 100px;
              padding-left: 2px;
              font-size: 12px;
            }
            .el-input__suffix {
              top: -8px;
            }
          }
        }
        /* 分页器 */
        .table_pagination {
          .el-pager {
            .number {
              min-width: 12px;
            }
          }
        }
      }
      .el-cascader {
        .el-input {
          width: 120px;
          .el-input__inner {
            width: 120px;
          }
          .el-input__suffix {
            right: 0px;
          }
        }
      }
      /* 左边的表格 */
      .flex-left {
        .table-img {
          .el-table {
            .el-table__header-wrapper {
              .el-table__header {
                .has-gutter {
                  tr {
                    th {
                      height: 32px;
                    }
                  }
                }
              }
            }
            .el-table__body-wrapper {
              .el-table__body {
                tbody {
                  tr {
                    padding: 0;
                    td {
                      padding: 0;
                      .cell {
                        box-sizing: border-box;
                        padding: 0;
                        .name-norm-container {
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                          .name-price {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .good-name {
                              height: 32px;
                              display: flex;
                              align-items: center;
                              font-size: 12px;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              flex: 1;
                              // background-color: skyblue;
                            }
                            .good-price {
                              width: 80px;
                              padding-left: 16px;
                            }
                          }
                          .outside-container {
                            width: 100%;
                            height: 36px;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            padding-bottom: 10px;
                            // background-color: salmon;
                            .inner-container {
                              margin-right: 6px;
                            }
                          }
                        }
                      }
                      &:first-child {
                        .cell {
                          padding-left: 20px;
                        }
                      }
                      &:last-child {
                        .cell {
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      /* 右边的表格 */
      .flex-right {
        .table-img {
          .el-table {
            .el-table__header-wrapper {
              .el-table__header {
                .has-gutter {
                  tr {
                    th {
                      height: 32px;
                      .cell {
                        padding: 0;
                      }
                    }
                    th:first-child {
                      .cell {
                        padding-left: 10px;
                      }
                    }
                  }
                }
              }
            }
            .el-table__body-wrapper {
              .el-table__body {
                tbody {
                  tr {
                    min-height: 32px;
                    padding: 0;
                    td {
                      min-height: 32px;
                      padding: 0;
                      .cell {
                        min-height: 32px;
                        // display: flex;
                        // align-items: center;
                        padding: 10px 0;
                        .delete-btn {
                          cursor: pointer;
                          height: 12px;
                          color: #3d74f2;
                          font-size: 12px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>